import React from 'react';
import type { Value } from 'react-phone-number-input';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import styles from './onboarding-step-phone-number.module.css';

type OnboardingStepPhoneNumberUiProps = {
  phone: string;
  phoneNumberError?: string;
  isSubmitting?: boolean;
  onUpdatePhoneNumber: (value: Value) => void;
};

const OnboardingStepPhoneNumberUi = (props: OnboardingStepPhoneNumberUiProps) => {
  const {
    phone,
    phoneNumberError,
    isSubmitting,
    onUpdatePhoneNumber,
  } = props;

  return (
    <>
      <div className={styles.title}>Please provide a valid phone number</div>
      <div
        className={`${styles.phoneInputContainer} ${phoneNumberError ? styles.phoneInputError : ''}`}
      >
        <PhoneInput
          id="phone-number-input"
          name="phoneNumber"
          placeholder="Enter phone number"
          value={phone as Value}
          onChange={onUpdatePhoneNumber}
          defaultCountry="GB"
          international
          countryCallingCodeEditable={false}
          disabled={isSubmitting}
          //autoComplete="off"
        />
      </div>
      {phoneNumberError && (
        <p className={styles.error}>{phoneNumberError}</p>
      )}
    </>
  );
};

export default OnboardingStepPhoneNumberUi;
